/** Paramètres de connexion à Keycloak */
export interface ConfigKeycloak {
    enabled: boolean;
    url: string;
    realm: string;
    clientId: string;
}

/**
 * Fusionne la section keycloak de assets/config.json dans celle de l'environnement :
 * les valeurs absentes (null ou vides) conservent celles de l'environnement.
 */
export function fusionnerConfigKeycloak(base: ConfigKeycloak, surcharge?: { [K in keyof ConfigKeycloak]?: ConfigKeycloak[K] | null } | null): ConfigKeycloak {
    const resultat = { ...base };
    if (typeof surcharge?.enabled === 'boolean') {
        resultat.enabled = surcharge.enabled;
    }
    for (const cle of ['url', 'realm', 'clientId'] as const) {
        const valeur = surcharge?.[cle];
        if (typeof valeur === 'string' && valeur !== '') {
            resultat[cle] = valeur;
        }
    }
    return resultat;
}
